import React, { useState } from "react";
import MuiTextField from "../../shares/MuiTextField";

const AdminReportOrderCardLeftPartTemplate = (props) => {
  const get_value_item = (index, type) => {
    if (props.inCurrentAdmin) {
      if (index == 0) {
        return props.data_item.admin_edit_size_one_num;
      } else if (index == 1) {
        return props.data_item.admin_edit_size_two_num;
      } else if (index == 2) {
        return props.data_item.admin_edit_size_three_num;
      } else if (index == 3) {
        return props.data_item.admin_edit_size_four_num;
      } else if (index == 4) {
        return props.data_item.admin_edit_size_five_num;
      } else if (index == 5) {
        return props.data_item.admin_edit_size_six_num;
      }
    } else {
      if (index == 0) {
        return props.data_item.size_one_num;
      } else if (index == 1) {
        return props.data_item.size_two_num;
      } else if (index == 2) {
        return props.data_item.size_three_num;
      } else if (index == 3) {
        return props.data_item.size_four_num;
      } else if (index == 4) {
        return props.data_item.size_five_num;
      } else if (index == 5) {
        return props.data_item.size_six_num;
      }
    }
  };

  const get_extra_value =(index)=>{
    if (index == 0) {
      return props.data_item.request_extra.size_one_num;
    } else if (index == 1) {
      return props.data_item.request_extra.size_two_num;
    } else if (index == 2) {
      return props.data_item.request_extra.size_three_num;
    } else if (index == 3) {
      return props.data_item.request_extra.size_four_num;
    } else if (index == 4) {
      return props.data_item.request_extra.size_five_num;
    } else if (index == 5) {
      return props.data_item.request_extra.size_six_num;
    }
  }
  return (
    <>
      <div className="grid grid-cols-3 md:grid-cols-7">
        <div className="hidden md:block">
          <p className=" text-center text-xs md:text-sm">سایز:</p>
          <p className=" text-center text-xs md:text-sm py-3">
            {props.label !== undefined ? props.label : "درخواست"}:
          </p>
        </div>

        {props.nums.map((item, index) => {
          return [
            <>
              <div className="mr-2">
                <p className=" text-center text-xs md:text-sm">{index + 1}</p>
                <MuiTextField
                  onChange={(e) =>
                    props.update_nums(props.ringId, index, e.target.value)
                  }
                  id="outlined-basic"
                  variant="outlined"
                  size="small"
                  defaultValue={
                    props.deliverProvider !== undefined
                      ? ""
                      : props.deliverProviderExtraItem !== undefined
                      ? get_extra_value(index)
                      : get_value_item(index)
                  }
                  disabled={props.cantEdit ? true : false}
                />
              </div>
            </>,
          ];
        })}
      </div>
    </>
  );
};

export default AdminReportOrderCardLeftPartTemplate;
